export default __webpack_public_path__ + "static/SRF 0030SG - Product Specifications & Technical Data-864d5ae5943ca55623a718be61276e21.pdf";